export default "__VITE_PUBLIC_ASSET__19c1269c__"